var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox agreement-page" },
    [
      _vm.actionError
        ? _c("el-alert", {
            staticClass: "error-alert",
            attrs: { title: _vm.actionError, type: "error", "show-icon": "" },
            on: {
              close: function ($event) {
                _vm.actionError = ""
              },
            },
          })
        : _vm._e(),
      _vm.visibleAgreementTypes.length
        ? _c(
            "el-card",
            {
              staticClass: "box-card",
              attrs: { bordered: false, shadow: "never" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "page-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", [_vm._v("协议版本治理")]),
                  _vm.hasPermission("create")
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: [_vm.permissions.create],
                              expression: "[permissions.create]",
                            },
                          ],
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.openCreate },
                        },
                        [_vm._v("新建草稿")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  staticClass: "type-tabs",
                  on: { "tab-click": _vm.handleTypeChange },
                  model: {
                    value: _vm.activeType,
                    callback: function ($$v) {
                      _vm.activeType = $$v
                    },
                    expression: "activeType",
                  },
                },
                _vm._l(_vm.visibleAgreementTypes, function (item) {
                  return _c("el-tab-pane", {
                    key: item.type,
                    attrs: { label: item.title, name: item.type },
                  })
                }),
                1
              ),
              _vm.hasPermission("history")
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.historyLoading,
                          expression: "historyLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.historyRows, size: "small" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "version",
                          label: "版本",
                          "min-width": "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "修订类型", "min-width": "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.revisionKindLabel(
                                          scope.row.revisionKind
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3367013050
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "noticeDays",
                          label: "公示天数",
                          width: "90",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "95" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-tag", { attrs: { size: "small" } }, [
                                    _vm._v(
                                      _vm._s(_vm.statusLabel(scope.row.status))
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3708931501
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "公示期（UTC）", "min-width": "210" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatUtc(scope.row.noticeStartAt)
                                      )
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatUtc(scope.row.noticeEndAt)
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2762010299
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "生效时间（UTC）", "min-width": "180" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(_vm.formatUtc(scope.row.effectiveAt))
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          951598789
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "changeSummary",
                          label: "变更摘要",
                          "min-width": "180",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          "min-width": "360",
                          fixed: "right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm.hasPermission("detail")
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [_vm.permissions.detail],
                                              expression:
                                                "[permissions.detail]",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.viewVersion(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("详情")]
                                      )
                                    : _vm._e(),
                                  _vm.canUseAction("update", scope.row) &&
                                  _vm.hasPermission("detail")
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [_vm.permissions.update],
                                              expression:
                                                "[permissions.update]",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editVersion(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      )
                                    : _vm._e(),
                                  _vm.canUseAction("notice", scope.row)
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [_vm.permissions.notice],
                                              expression:
                                                "[permissions.notice]",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openNotice(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("开始公示")]
                                      )
                                    : _vm._e(),
                                  _vm.canUseAction("approve", scope.row)
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [_vm.permissions.approve],
                                              expression:
                                                "[permissions.approve]",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openApprove(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("审批")]
                                      )
                                    : _vm._e(),
                                  _vm.canUseAction("publish", scope.row)
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [_vm.permissions.publish],
                                              expression:
                                                "[permissions.publish]",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openPublish(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("发布")]
                                      )
                                    : _vm._e(),
                                  _vm.canUseAction("withdraw", scope.row)
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [_vm.permissions.withdraw],
                                              expression:
                                                "[permissions.withdraw]",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openWithdraw(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("撤回")]
                                      )
                                    : _vm._e(),
                                  _vm.hasPermission("download")
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [_vm.permissions.download],
                                              expression:
                                                "[permissions.download]",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                            loading:
                                              _vm.downloadingVersion ===
                                              scope.row.version,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downloadVersion(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("下载 HTML")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          18725912
                        ),
                      }),
                    ],
                    1
                  )
                : _c("div", { staticClass: "empty-tip" }, [
                    _vm._v("当前账号没有协议历史查看权限。"),
                  ]),
              _vm.hasPermission("history") && _vm.historyTotal
                ? _c("el-pagination", {
                    staticClass: "table-pagination",
                    attrs: {
                      background: "",
                      "current-page": _vm.historyQuery.page,
                      "page-size": _vm.historyQuery.size,
                      "page-sizes": _vm.pageSizes,
                      total: _vm.historyTotal,
                      layout: "total, sizes, prev, pager, next, jumper",
                    },
                    on: {
                      "size-change": _vm.handleHistorySizeChange,
                      "current-change": _vm.handleHistoryPageChange,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.hasPermission("feedbackList")
        ? _c(
            "el-card",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: [_vm.permissions.feedbackList],
                  expression: "[permissions.feedbackList]",
                },
              ],
              staticClass: "box-card feedback-card",
              attrs: { bordered: false, shadow: "never" },
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("协议反馈"),
              ]),
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small" },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "协议类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "全部类型" },
                          model: {
                            value: _vm.feedbackQuery.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.feedbackQuery, "type", $$v)
                            },
                            expression: "feedbackQuery.type",
                          },
                        },
                        _vm._l(_vm.visibleAgreementTypes, function (item) {
                          return _c("el-option", {
                            key: item.type,
                            attrs: { label: item.title, value: item.type },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "版本" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入版本" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.searchFeedback($event)
                          },
                        },
                        model: {
                          value: _vm.feedbackQuery.version,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.feedbackQuery,
                              "version",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "feedbackQuery.version",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "处置状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "全部状态" },
                          model: {
                            value: _vm.feedbackQuery.disposition,
                            callback: function ($$v) {
                              _vm.$set(_vm.feedbackQuery, "disposition", $$v)
                            },
                            expression: "feedbackQuery.disposition",
                          },
                        },
                        _vm._l(_vm.feedbackDispositionOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.searchFeedback },
                        },
                        [_vm._v("查询")]
                      ),
                      _c("el-button", { on: { click: _vm.resetFeedback } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.feedbackLoading,
                      expression: "feedbackLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.feedbackRows, size: "small" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "70" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "协议", "min-width": "170" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.agreementTypeLabel(scope.row.type))
                                ),
                              ]),
                              _c("div", [_vm._v(_vm._s(scope.row.version))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      586880751
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "反馈主体", "min-width": "160" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(scope.row.subjectType || "-")),
                              ]),
                              _c("div", [
                                _vm._v(_vm._s(scope.row.subjectId || "-")),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1895991105
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "处置状态", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.dispositionLabel(scope.row.disposition)
                                )
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2430532890
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "反馈时间（UTC）", "min-width": "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.formatUtc(scope.row.createdAt))
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3797658664
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "130", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.hasPermission("feedbackDetail")
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            _vm.permissions.feedbackDetail,
                                          ],
                                          expression:
                                            "[permissions.feedbackDetail]",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openFeedbackDetail(
                                            scope.row.id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("详情")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("feedbackDisposition")
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            _vm.permissions.feedbackDisposition,
                                          ],
                                          expression:
                                            "[permissions.feedbackDisposition]",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openFeedbackDisposition(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("处置")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      761549438
                    ),
                  }),
                ],
                1
              ),
              _vm.feedbackTotal
                ? _c("el-pagination", {
                    staticClass: "table-pagination",
                    attrs: {
                      background: "",
                      "current-page": _vm.feedbackQuery.page,
                      "page-size": _vm.feedbackQuery.size,
                      "page-sizes": _vm.pageSizes,
                      total: _vm.feedbackTotal,
                      layout: "total, sizes, prev, pager, next, jumper",
                    },
                    on: {
                      "size-change": _vm.handleFeedbackSizeChange,
                      "current-change": _vm.handleFeedbackPageChange,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.editorMode === "create"
                ? "新建协议草稿"
                : _vm.editorMode === "edit"
                ? "编辑协议草稿"
                : "协议版本详情",
            visible: _vm.editorVisible,
            width: "900px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editorVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.versionLoading,
                  expression: "versionLoading",
                },
              ],
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "110px", size: "small" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "协议类型" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.agreementTypeLabel(_vm.activeType),
                                  disabled: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "版本" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled:
                                    !!_vm.currentVersion || _vm.editorReadonly,
                                  maxlength: "64",
                                },
                                model: {
                                  value: _vm.editorForm.version,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editorForm,
                                      "version",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "editorForm.version",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "修订类型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: _vm.editorReadonly },
                                  model: {
                                    value: _vm.editorForm.revisionKind,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editorForm,
                                        "revisionKind",
                                        $$v
                                      )
                                    },
                                    expression: "editorForm.revisionKind",
                                  },
                                },
                                _vm._l(_vm.revisionKinds, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "公示天数" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  value:
                                    _vm.revisionNoticeDays +
                                    " 天（服务端派生）",
                                  disabled: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "变更摘要" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          disabled: _vm.editorReadonly,
                          maxlength: "1000",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.editorForm.changeSummary,
                          callback: function ($$v) {
                            _vm.$set(_vm.editorForm, "changeSummary", $$v)
                          },
                          expression: "editorForm.changeSummary",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "协议正文" } },
                    [
                      !_vm.editorReadonly
                        ? _c("Tinymce", {
                            key: _vm.editorKey,
                            model: {
                              value: _vm.editorForm.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.editorForm, "content", $$v)
                              },
                              expression: "editorForm.content",
                            },
                          })
                        : _c("div", {
                            staticClass: "agreement-content",
                            domProps: {
                              innerHTML: _vm._s(_vm.editorForm.content),
                            },
                          }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v(
                      " MINOR 由服务端派生 noticeDays=7；MATERIAL 由服务端派生 noticeDays=15。进入 NOTICE 后正文和变更摘要不可修改。 "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editorVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.editorMode !== "detail" && !_vm.isContentReadonly
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            _vm.currentVersion
                              ? _vm.permissions.update
                              : _vm.permissions.create,
                          ],
                          expression:
                            "[currentVersion ? permissions.update : permissions.create]",
                        },
                      ],
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.saveDraft },
                    },
                    [_vm._v("保存草稿")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "开始公示",
            visible: _vm.noticeVisible,
            width: "560px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.noticeVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "130px", size: "small" } },
            [
              _c("el-form-item", { attrs: { label: "版本" } }, [
                _vm._v(_vm._s(_vm.actionVersion && _vm.actionVersion.version)),
              ]),
              _c("el-form-item", { attrs: { label: "修订类型" } }, [
                _vm._v(
                  _vm._s(
                    _vm.revisionKindLabel(
                      _vm.actionVersion && _vm.actionVersion.revisionKind
                    )
                  )
                ),
              ]),
              _c("el-form-item", { attrs: { label: "公示天数" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.noticeDaysFor(
                        _vm.actionVersion && _vm.actionVersion.revisionKind
                      )
                    ) +
                    " 天（服务端派生） "
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "公示开始" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "datetime", placeholder: "请选择开始时间" },
                    on: { change: _vm.updateNoticeEnd },
                    model: {
                      value: _vm.noticeForm.noticeStartAt,
                      callback: function ($$v) {
                        _vm.$set(_vm.noticeForm, "noticeStartAt", $$v)
                      },
                      expression: "noticeForm.noticeStartAt",
                    },
                  }),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("按所选时刻转换为 UTC ISO 提交。"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "公示结束（UTC）" } },
                [
                  _c("el-input", {
                    attrs: { value: _vm.noticeForm.noticeEndAt, readonly: "" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.noticeVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [_vm.permissions.notice],
                      expression: "[permissions.notice]",
                    },
                  ],
                  attrs: { type: "primary", loading: _vm.transitionSaving },
                  on: { click: _vm.submitNotice },
                },
                [_vm._v("确认开始公示")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批协议版本",
            visible: _vm.approveVisible,
            width: "520px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approveVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px", size: "small" } },
            [
              _c("el-form-item", { attrs: { label: "版本" } }, [
                _vm._v(_vm._s(_vm.actionVersion && _vm.actionVersion.version)),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "审批依据", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "255",
                      placeholder: "请输入 approvalRef",
                    },
                    model: {
                      value: _vm.approveForm.approvalRef,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.approveForm,
                          "approvalRef",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "approveForm.approvalRef",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.approveVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [_vm.permissions.approve],
                      expression: "[permissions.approve]",
                    },
                  ],
                  attrs: { type: "primary", loading: _vm.transitionSaving },
                  on: { click: _vm.submitApprove },
                },
                [_vm._v("确认审批")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "发布协议版本",
            visible: _vm.publishVisible,
            width: "520px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.publishVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "120px", size: "small" } },
            [
              _c("el-form-item", { attrs: { label: "版本" } }, [
                _vm._v(_vm._s(_vm.actionVersion && _vm.actionVersion.version)),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "生效时间", required: "" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "datetime", placeholder: "请选择生效时间" },
                    model: {
                      value: _vm.publishForm.effectiveAt,
                      callback: function ($$v) {
                        _vm.$set(_vm.publishForm, "effectiveAt", $$v)
                      },
                      expression: "publishForm.effectiveAt",
                    },
                  }),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v(
                      "审批与发布是独立操作；生效时间按 UTC ISO 提交，且不得早于公示结束时间。"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.publishVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [_vm.permissions.publish],
                      expression: "[permissions.publish]",
                    },
                  ],
                  attrs: { type: "primary", loading: _vm.transitionSaving },
                  on: { click: _vm.submitPublish },
                },
                [_vm._v("确认发布")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "撤回协议版本",
            visible: _vm.withdrawVisible,
            width: "520px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.withdrawVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px", size: "small" } },
            [
              _c("el-form-item", { attrs: { label: "版本" } }, [
                _vm._v(_vm._s(_vm.actionVersion && _vm.actionVersion.version)),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "撤回原因", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "1000",
                      "show-word-limit": "",
                      placeholder: "请输入撤回原因",
                    },
                    model: {
                      value: _vm.withdrawForm.reason,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.withdrawForm,
                          "reason",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "withdrawForm.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.withdrawVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [_vm.permissions.withdraw],
                      expression: "[permissions.withdraw]",
                    },
                  ],
                  attrs: { type: "danger", loading: _vm.transitionSaving },
                  on: { click: _vm.submitWithdraw },
                },
                [_vm._v("确认撤回")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "反馈详情",
            visible: _vm.feedbackDetailVisible,
            width: "680px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.feedbackDetailVisible = $event
            },
          },
        },
        [
          _vm.selectedFeedback
            ? _c(
                "el-form",
                { attrs: { "label-width": "110px", size: "small" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "反馈 ID" } }, [
                            _vm._v(_vm._s(_vm.selectedFeedback.id)),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "请求 ID" } }, [
                            _vm._v(
                              _vm._s(_vm.selectedFeedback.requestId || "-")
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "协议类型" } }, [
                            _vm._v(_vm._s(_vm.selectedFeedback.type)),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "协议版本" } }, [
                            _vm._v(_vm._s(_vm.selectedFeedback.version)),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "主体类型" } }, [
                            _vm._v(
                              _vm._s(_vm.selectedFeedback.subjectType || "-")
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "主体 ID" } }, [
                            _vm._v(
                              _vm._s(_vm.selectedFeedback.subjectId || "-")
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "协议 Hash" } }, [
                    _vm._v(_vm._s(_vm.selectedFeedback.hash || "-")),
                  ]),
                  _c("el-form-item", { attrs: { label: "反馈内容" } }, [
                    _c("pre", { staticClass: "feedback-content" }, [
                      _vm._v(_vm._s(_vm.selectedFeedback.content)),
                    ]),
                  ]),
                  _c("el-form-item", { attrs: { label: "联系方式" } }, [
                    _vm._v(_vm._s(_vm.selectedFeedback.contact || "未提供")),
                  ]),
                  _c("el-form-item", { attrs: { label: "处置状态" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.dispositionLabel(_vm.selectedFeedback.disposition)
                      )
                    ),
                  ]),
                  _c("el-form-item", { attrs: { label: "处置备注" } }, [
                    _vm._v(_vm._s(_vm.selectedFeedback.dispositionNote || "-")),
                  ]),
                  _c("el-form-item", { attrs: { label: "处置人" } }, [
                    _vm._v(_vm._s(_vm.selectedFeedback.disposedBy || "-")),
                  ]),
                  _c("el-form-item", { attrs: { label: "处置时间" } }, [
                    _vm._v(
                      _vm._s(_vm.formatUtc(_vm.selectedFeedback.disposedAt))
                    ),
                  ]),
                  _c("el-form-item", { attrs: { label: "反馈时间" } }, [
                    _vm._v(
                      _vm._s(_vm.formatUtc(_vm.selectedFeedback.createdAt))
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.feedbackDetailVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "处置反馈",
            visible: _vm.feedbackDispositionVisible,
            width: "560px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.feedbackDispositionVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "处置结果", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择处置结果" },
                      model: {
                        value: _vm.feedbackDispositionForm.disposition,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.feedbackDispositionForm,
                            "disposition",
                            $$v
                          )
                        },
                        expression: "feedbackDispositionForm.disposition",
                      },
                    },
                    _vm._l(
                      _vm.feedbackDispositionOptions.filter(function (option) {
                        return option.value !== "PENDING"
                      }),
                      function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "处置备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "1000",
                      "show-word-limit": "",
                      placeholder: "请输入处置备注",
                    },
                    model: {
                      value: _vm.feedbackDispositionForm.note,
                      callback: function ($$v) {
                        _vm.$set(_vm.feedbackDispositionForm, "note", $$v)
                      },
                      expression: "feedbackDispositionForm.note",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.feedbackDispositionVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [_vm.permissions.feedbackDisposition],
                      expression: "[permissions.feedbackDisposition]",
                    },
                  ],
                  attrs: {
                    type: "primary",
                    loading: _vm.feedbackDispositionSaving,
                  },
                  on: { click: _vm.submitFeedbackDisposition },
                },
                [_vm._v("确认处置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }